namespace Portico.Services {
    import Inject = Portico.Decorators.Inject;
    import Service = Portico.Decorators.Service;
    import LogLevel = Portico.Models.LogLevel;

    export type errorCallback<T> = (error: T, loggingLevel: Portico.Models.LogLevel) => void;

    export interface IErrorService {
        handleError(error: Portico.Models.PorticoException, callback?: errorCallback<Portico.Models.PorticoException>): void;
        handleError(error: string, callback?: errorCallback<string>): void;
        handleError(error: string[], callback?: errorCallback<string[]>): void;
        handleError(error: Portico.Models.PorticoException | string | string[],
            callback?: errorCallback<Portico.Models.PorticoException | string | string[]>): void;
    }

    @Service('app', 'errorService')
    @Inject('$log', 'dataService', '$http')
    export class ErrorService {
        constructor(
            private $log: angular.ILogService,
            private dataService: Portico.Services.IDataService,
            private $http: ng.IHttpService
        ) { }

        public handleError(error: Portico.Models.PorticoException, callback?: errorCallback<Portico.Models.PorticoException>): void;
        public handleError(error: string, callback?: errorCallback<string>): void;
        public handleError(error: string[], callback?: errorCallback<string[]>): void;
        public handleError(error: Portico.Models.PorticoException | string | string[],
            callback?: errorCallback<any>): void {

            var loggingLevel = this.dataService.getEnvironmentValue('logging-level') != null ?
                LogLevel[this.dataService.getEnvironmentValue('logging-level').toLowerCase()] : LogLevel.none;

            var errorObj = null;

            if (error instanceof Portico.Models.PorticoException) {
                errorObj = error;

                if (loggingLevel !== LogLevel.none && loggingLevel !== LogLevel.record) {
                    this.$log.error("Portico error: " + error.errorMessage);

                    if (loggingLevel === LogLevel.verbose) {
                        this.$log.error("Details: " + error.rawError);
                        this.$log.error("Raw Dump: " + error.dataDump);
                    }
                }
            }
            else {
                const messages = Array.isArray(error) ? error.join(' | ') : error;
                errorObj = new Portico.Models.PorticoException(messages, '');

                if (loggingLevel !== LogLevel.none) {
                    this.$log.error(messages);
                }
            }

            if (loggingLevel === LogLevel.record) {
                // send error to the server to be logged
                this.logToServer(errorObj);
            }

            if (callback) {
                callback(error, loggingLevel);
            }
        }

        private logToServer(error: Portico.Models.PorticoException | string): void {
            this.$http.defaults.headers.common['accept'] = 'application/json';
            this.$http.defaults.headers.common["X-Requested-With"] = 'XMLHttpRequest';

            try {
                this.$http.post('/api/ClientError', error)
                    .catch(() => { });
            }
            catch(e) { }

        }
    }
}